import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from 'components/Tooltip';

import { CADButton, Group, GroupDropdown } from './ButtonGroup.styled';

export default function ButtonGroup({ buttonGroups, transparent, itemProps }) {
  const tooltipId = `tooltip_toolbar`;

  return (
    <>
      {buttonGroups &&
        buttonGroups.map((buttons, i) => {
          const groupKey = `ButtonGroup_${i}`;
          return (
            <div key={groupKey}>
              <Tooltip delayShow={500} place='bottom' id={tooltipId} />
              <Group>
                {buttons &&
                  buttons.map(
                    (
                      {
                        icon,
                        viewBox = '0 0 24 24',
                        tooltip,
                        items,
                        onClick,
                        isActive,
                        isVisible,
                        hasDropdown,
                        dropdownContent,
                        customColor,
                        dataIntercomTarget,
                        isDisabled = false,
                        dropdownDirection = 'right',
                        renderIcon,
                        ...buttonProps
                      },
                      j,
                    ) => {
                      const innerKey = `ButtonGroup_${i}_${j}`;

                      return (
                        <li
                          key={innerKey}
                          className='w-full h-full flex-center'
                          style={{
                            width: '100%',
                            height: '100%',
                          }}
                          {...(itemProps || {})}
                        >
                          {items?.length}
                          {dropdownContent && isActive && (
                            <GroupDropdown
                              dropdownDirection={dropdownDirection}
                            >
                              {dropdownContent}
                            </GroupDropdown>
                          )}
                          <CADButton
                            icon={icon}
                            iconViewBox={viewBox}
                            items={items}
                            variant='tertiary'
                            size='default'
                            data-for={tooltipId}
                            data-tip={tooltip}
                            data-tip-disable={dropdownContent && isActive}
                            onClick={onClick}
                            isActive={isActive}
                            style={{
                              width: 40,
                              height: 40,
                              padding: 0,
                              top: 0,
                              margin: 0,
                            }}
                            isVisible={isVisible}
                            customColor={customColor}
                            hasDropdown={hasDropdown}
                            isDisabled={isDisabled}
                            appearance='plain'
                            data-intercom-target={dataIntercomTarget}
                            transparent={transparent}
                            renderIcon={renderIcon}
                            {...buttonProps}
                          />
                        </li>
                      );
                    },
                  )}
              </Group>
            </div>
          );
        })}
    </>
  );
}

ButtonGroup.propTypes = {
  /**
   * Array of buttons. Recives the icon, text of the tooltip, callback and isActive prop to show the button as active.
   */
  buttonGroups: PropTypes.array,

  itemProps: PropTypes.any,
  /**
   * Tooltip id
   */
  tooltipId: PropTypes.string,
  /**
   * background transparency
   */
  transparent: PropTypes.bool,
};

ButtonGroup.defaultProps = {
  tooltipId: 'defaultTooltipId',
};
